import type { PostHogConfig } from "posthog-js"
import { postHogState } from "@/lib/posthog/state"

type PostHogAppCaptureClient = {
  set_config(config: Partial<PostHogConfig>): void
  sessionRecordingStarted(): boolean
  startSessionRecording(
    override?: { sampling?: boolean; linked_flag?: boolean; url_trigger?: true; event_trigger?: true } | true,
  ): void
}

const APP_SESSION_RECORDING_OVERRIDE = {
  event_trigger: true,
  linked_flag: true,
  sampling: true,
  url_trigger: true,
} as const

export function syncPostHogAppCapture(client: PostHogAppCaptureClient, pathname = window.location.pathname) {
  const isAppRoute = pathname.startsWith("/app")
  const config = {
    autocapture: isAppRoute,
    capture_exceptions: isAppRoute,
    capture_pageleave: isAppRoute,
    disable_external_dependency_loading: false,
    disable_session_recording: !isAppRoute,
    disable_surveys: !isAppRoute,
  } satisfies Partial<PostHogConfig>
  const configSignature = JSON.stringify(config)

  if (postHogState.lastAppCaptureConfigSignature !== configSignature) {
    client.set_config(config)
    postHogState.lastAppCaptureConfigSignature = configSignature
  }

  if (isAppRoute && !client.sessionRecordingStarted()) {
    client.startSessionRecording(APP_SESSION_RECORDING_OVERRIDE)
  }
}
